import BootstrapModal from "bootstrap/js/dist/modal";

import { UnshadowedElement, html } from "../lib/unshadowed.js";
import { UserAvatar } from "./user-avatar.js";
import { ShowLinkedUpdate } from "../lib/linked-update-modal.js";

UserAvatar.Register();

/**
 * Display a row of recent activity
 * Expects activity to be a nMealTrainActivity
 */
export class RecentActivityRow extends UnshadowedElement {
    static elementName() { return "recent-activity-row" }

    static properties = {
        activity: { type: Object },
        isInModal: { type: Boolean },
    };

    HideActivityModal() {
        const modalElement = document.getElementById("modalTrainActivity");
        if (modalElement) {
            const modal = BootstrapModal.getOrCreateInstance(modalElement);
            modal.hide();
        }
    }

    ShowUpdate(activity) {
        this.HideActivityModal();
        ShowLinkedUpdate(activity.ObjectId);
    }

    render() {
        const contents = html`
            <user-avatar avatar=${this.activity.User && this.activity.User.Avatar} initials=${this.activity.User && this.activity.User.Initials}></user-avatar>
            <div>
                <p class="activity-row__title">${this.activity.FullName}</p>
                <ul class="activity-row__data"><li>${this.activity.Description}</li><li>${this.activity.TimeAgo}</li></ul>
            </div>
        `;
        if (this.activity.TypeId === 4 && !this.isInModal) {
            return html`<a class="activity-row" data-bs-toggle="modal" data-bs-target="#modalTrainDonations" data-bs-dismiss="modal">${contents}</a>`;
        } else if (this.activity.TypeId === 5) {
            return html`<a class="activity-row" @click=${() => this.ShowUpdate(this.activity)}>${contents}</a>`;
        } else {
            return html`<div class="activity-row">${contents}</div>`;
        }
    }
}
